import bridge from './bridge';
import { IConfigCache, IConfigCacheAssets, IConfigCacheOAuthToken } from '../interface/config';
import { ILog } from '../interface/log';

function _isConfigToken(config: any): config is IConfigCacheOAuthToken {
    return 'tokenPath' in config;
}

function _isConfigAsset(config: any): config is IConfigCacheAssets {
    return (
        'cacheName' in config &&
        'expiration' in config &&
        'maxEntries' in config &&
        'matcher' in config
    );
}

function _tokenConfigs(config: IConfigCache): Array<IConfigCacheOAuthToken> {
    const arr: Array<IConfigCacheOAuthToken> = [];

    for (const settings of Object.values(config)) {
        if (!_isConfigToken(settings)) {
            continue;
        }
        arr.push(settings);
    }

    return arr;
}

function _assetConfigs(config: IConfigCache): Array<IConfigCacheAssets> {
    const arr: Array<IConfigCacheAssets> = [];

    for (const settings of Object.values(config)) {
        if (!_isConfigAsset(settings)) {
            continue;
        }
        arr.push(settings);
    }

    return arr;
}

function setupSWRules(log: ILog, worker: ServiceWorker, config: IConfigCache): void {
    log.info('SW-Rules, Adding Cache First');

    for (const settings of _assetConfigs(config)) {
        log.info(
            `SW-Rules, Registering cache-first: ${settings.cacheName}, ${JSON.stringify(settings)}`,
        );
        bridge.addCacheFirst(
            worker,
            /* matcher: */ settings.matcher,
            /* maxAge: */ settings.expiration,
            /* maxEntries: */ settings.maxEntries,
            /* cacheName */ settings.cacheName,
        );
    }

    for (const settings of _tokenConfigs(config)) {
        log.info(`SW-Rules, Adding OAuth Token Cache: %{settings.tokenPath}`);
        bridge.addOAuthTokenCache(worker, settings.tokenPath);
    }
}

export default setupSWRules;
